import { render } from "./detailsDialog.vue?vue&type=template&id=905fa694&scoped=true"
import script from "./detailsDialog.vue?vue&type=script&lang=js"
export * from "./detailsDialog.vue?vue&type=script&lang=js"

import "./detailsDialog.vue?vue&type=style&index=0&id=905fa694&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-905fa694"]])

export default __exports__